const DeviceStatus = {
    ACTIVE: "ACTIVE",
    ARCHIVED: "ARCHIVED"
}

export default DeviceStatus;